import { render, staticRenderFns } from "./common-rmsg.vue?vue&type=template&id=5ea06e98"
import script from "./common-rmsg.vue?vue&type=script&lang=js"
export * from "./common-rmsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports